var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-slot'),_c('b-card',{staticClass:"border-top-primary border-3 border-table-radius px-0",attrs:{"no-body":""}},[_c('GridTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }